<div class="empty-invoices">
  <h2 [innerHTML]="title"></h2>
  <p class="mt--050 empty-invoices__subtitle" [innerHTML]="text"></p>
  <img src="assets/empty-invoices-updated.svg" width="608" height="384" alt="" class="mt--400 empty-invoices__img">
</div>
